import React from "react"
import { Route, Switch, Redirect } from "react-router-dom"
import { connect } from "react-redux"
import _ from "../../utils/lodashUtils"
import PrivateRoute from "../Routing/privateRoutes"
import SignInPage from "../../containers/SignInPage/SignInPage"
import ContactInfoPage from "../../containers/ContactInfoPage/ContactInfoPage"
import RegisterNewUserPage from "../../containers/RegisterNewUserPage/RegisterNewUserPage"
import IntegrationSetupPage from "../../containers/IntegrationSetupPage/IntegrationSetupPage"
import OtpVerificationPage from "../../containers/OtpVerificationPage/OtpVerificationPage"
import ConfirmDatePage from "../../containers/ConfirmDatePage/ConfirmDatePage"
import CheckoutPage from "../../containers/CheckoutPage/CheckoutPage"
import CheckoutDetail from "../../containers/CheckoutPage/CheckoutDetail"
import CheckoutWaitingPage from "../../containers/CheckoutPage/CheckoutWaitingPage"
import CheckoutPaymentPage from "../../containers/CheckoutPage/CheckoutPaymentPage"
import OrderSuccessPage from "../../containers/CheckoutPage/OrderSuccess"
import Landing from "../../containers/Landing/landing"
import GetAddressPage from "../../containers/GetAddressPage/GetAddressPage"
import ChooseRestaurantPage from "../../containers/ChooseRestaurantPage/ChooseRestaurantPage"
import MyPartnerDetailsPage from "../../containers/MyPartnerPage/MyPartnerDetailsPage"
import PartnerSignUpWithInvite from "../../containers/PartnerSignUpWithInvite/PartnerSignUpWithInvite"
import DashboardPage from "../../containers/Dashboard/Dashboard"
import FirebaseProvider from "../../firebase/FirebaseProvider"
import PlannedDateWindow from "../PlannedDateWindow/PlannedDateWindow"
import RegisterNewUserMobile from "../../containers/RegisterNewUserMobile/RegisterNewUserMobile"
import SignInPageByEmail from "../../containers/SignInPageByEmail/SignInPageByEmail"
import EmailVerification from "../../containers/ForgotPassword/EmailVerification"
import ForgotPassword from "../../containers/ForgotPassword/ForgotPassword"
import CheckRestaurants from "../../containers/CheckRestaurants/CheckRestaurants"
import DateWaitPage from "../../containers/DateWaitPage/DateWaitPage"
import GetHelp from "../../containers/HelpPage/HelpPage"
import UnAuthenticatedRoute from "../../containers/SignInPage/UnAuthenticatedRoute"
import JournalPage from "../../containers/JournalPage/JournalPage"
import MeetConcierge from "../../containers/JournalPage/MeetConcierge"
const Routes = props => {
  const { isAuthenticated } = props
  return (
    <Switch>
      <UnAuthenticatedRoute exact path="/login" component={SignInPage} />
      <UnAuthenticatedRoute
        exact
        path="/login-email"
        component={SignInPageByEmail}
      />
      <UnAuthenticatedRoute
        exact
        path="/register-email"
        component={RegisterNewUserPage}
      />
      <UnAuthenticatedRoute
        exact
        path="/register"
        component={RegisterNewUserMobile}
      />
      <Route exact path="/verify-otp" component={OtpVerificationPage} />
      <Route
        exact
        path="/verify-email/:success"
        component={EmailVerification}
      />
      <Route
        exact
        path="/accounts/reset/:uuid/:token"
        component={ForgotPassword}
      />
      <Route exact path="/accounts/reset/:uuid" component={ForgotPassword} />
      <Route
        exact
        path="/activate-account/:token/:email"
        component={SignInPageByEmail}
      />
      <Route
        exact
        path="/sign-up-with-invite/:inviteCode"
        component={PartnerSignUpWithInvite}
      />
      <FirebaseProvider {...props}>
        <PrivateRoute exact path="/" component={Landing} />
        <PrivateRoute exact path="/contact" component={ContactInfoPage} />
        <PrivateRoute
          exact
          path="/integrations"
          component={IntegrationSetupPage}
        />
        <PrivateRoute
          exact
          path="/plan-new-date"
          component={PlannedDateWindow}
          chatHeaderEnabled
        />
        <PrivateRoute
          exact
          path="/confirm-date"
          component={ConfirmDatePage}
          chatHeaderEnabled
        />
        <PrivateRoute
          exact
          path="/checkout"
          component={CheckoutPage}
          chatHeaderEnabled
        />
        <PrivateRoute
          exact
          path="/checkout/detail"
          component={CheckoutDetail}
          chatHeaderEnabled
        />
        <PrivateRoute
          exact
          path="/checkout/wait"
          component={CheckoutWaitingPage}
          chatHeaderEnabled
        />
        <PrivateRoute
          exact
          path="/checkout/payment"
          component={CheckoutPaymentPage}
          chatHeaderEnabled
        />
        <PrivateRoute
          exact
          path="/order/success"
          component={OrderSuccessPage}
          chatHeaderEnabled
        />
        <PrivateRoute
          exact
          path="/get-address"
          component={GetAddressPage}
          chatHeaderEnabled
        />
        <PrivateRoute
          exact
          path="/choose-restaurant"
          component={ChooseRestaurantPage}
          chatHeaderEnabled
        />
        <PrivateRoute
          exact
          path="/date/wait"
          component={DateWaitPage}
          chatHeaderEnabled
        />
        <PrivateRoute
          exact
          path="/my-partner"
          component={MyPartnerDetailsPage}
        />
        <PrivateRoute exact path="/get-help" component={GetHelp} />
        <PrivateRoute
          exact
          path="/check-restaurants"
          component={CheckRestaurants}
          chatHeaderEnabled
        />
        <PrivateRoute
          exact
          path="/bond-over-memories"
          component={JournalPage}
          chatHeaderEnabled
        />
        <PrivateRoute
          exact
          path="/meet-concierge"
          component={MeetConcierge}
          chatHeaderEnabled
        />
        <PrivateRoute exact path="/dashboard" component={DashboardPage} />
      </FirebaseProvider>
      <Redirect to="/" />
    </Switch>
  )
}

const mapStateToProps = state => ({
  isAuthenticated: _.get(state, "auth.isAuthenticated", false),
})

export default connect(mapStateToProps)(Routes)
